import { Button } from "react-bootstrap";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; // ✅ Add useNavigate
import { useEffect } from "react";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ✅ Add navigate
  const cartreduxdata = useSelector((state) => state.cart);
  const packagesreduxdata = useSelector((state) => state.packages);
  const personalisedreduxdata = useSelector((state) => state.personalised);
  const checkoutstatus = useSelector((state) => state.checkoutstatus);
  const [serviceType, setServiceType] = useState(null);

  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    localStorage.setItem("refresh", JSON.stringify(1));
  }, []);

  useEffect(() => {
    const storedServiceType = localStorage.getItem("service_type");
    setServiceType(Number(storedServiceType));
  }, []);

  console.log("service_type in Cart:", serviceType);

  // Calculate totals
  var total = 0;
  cartreduxdata.forEach((item) => {
    total += item.cartamount;
  });

  var packtotal = 0;
  packagesreduxdata.forEach((item) => {
    if (item && item.cartamount) {
      packtotal += item.cartamount;
    }
  });

  var personalisedtotal = 0;
  personalisedreduxdata.forEach((item) => {
    if (item && item.cartamount) {
      personalisedtotal += item.cartamount;
    }
  });

  const grandTotal =
    parseInt(total) + parseInt(packtotal) + parseInt(personalisedtotal);

  // ✅ Handle add to cart (increase quantity)
  const handleAddtoCart = (item) => {
    setRefresh(!refresh);
    dispatch({ type: "ADD_TO_CART", payload: item });
  };

  // ✅ Handle minus from cart (decrease quantity)
  const handleMinustoCart = (item) => {
    var packclear = { productid: item.productid, ustring: item.packages };
    dispatch({ type: "MINUS_TO_CART", payload: item });
    dispatch({ type: "MINUS_PACKAGES_WITH_CART", payload: packclear });
    setRefresh(!refresh);
  };

  // ✅ Handle delete cart item
  const handleDeleteCartItem = (item) => {
    dispatch({ type: "CLEAR_SINGLE_CART_ITEM", payload: item });

    var packclear = { productid: item.productid, ustring: item.packages };
    dispatch({ type: "CLEAR_PACKAGES_FOR_PRODUCT", payload: packclear });

    // If this was the last item, clear personalised too
    if (cartreduxdata.length === 1) {
      dispatch({ type: "CLEAR_PERSONALISED" });
    }

    setRefresh(!refresh);
  };

  // ✅ Handle quantity input change with proper validation
  const handleQuantityChange = (item, newQty) => {
    const qty = parseInt(newQty);

    // If empty or invalid, don't update (will revert to original)
    if (newQty === "" || isNaN(qty)) {
      return;
    }

    // Validate quantity (1-50)
    if (qty < 1 || qty > 50) {
      return;
    }

    // Calculate difference
    const currentQty = item.cartquantity;
    const difference = qty - currentQty;

    if (difference > 0) {
      // Add items
      for (let i = 0; i < difference; i++) {
        handleAddtoCart(item);
      }
    } else if (difference < 0) {
      // Remove items (but never go below 1)
      const itemsToRemove = Math.min(Math.abs(difference), currentQty - 1);
      for (let i = 0; i < itemsToRemove; i++) {
        handleMinustoCart(item);
      }
    }
  };

  // ✅ NEW: Handle proceed to checkout with authentication check
  const handleProceedToCheckout = () => {
    const userFromStorage = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!userFromStorage || !token) {
      console.log("⚠️ User not logged in, redirecting to login");
      dispatch({ type: "CHECKOUT_STATUS", payload: 1 });
      navigate("/login");
    } else {
      console.log("✅ User authenticated, proceeding to details");
      dispatch({ type: "CHECKOUT_STATUS", payload: 1 });
      navigate("/details");
    }
  };

  // ✅ Check if cart is empty
  const isCartEmpty = cartreduxdata.length === 0;

  return (
    <div>
      <div className="cartSec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 style={{ marginBottom: "30px" }}>Your Shopping Cart</h2>

              {isCartEmpty ? (
                <div style={{ textAlign: "center", padding: "50px 20px" }}>
                  <i
                    className="fa-solid fa-cart-shopping"
                    style={{
                      fontSize: "60px",
                      color: "#ccc",
                      marginBottom: "20px",
                    }}
                  ></i>
                  <h3>Your cart is empty</h3>
                  <p style={{ color: "#666", marginBottom: "30px" }}>
                    Add items to get started!
                  </p>
                  <Link to="/">
                      <Button className="btn2" variant="primary">
                        Continue Shopping
                      </Button>
                  </Link>
                </div>
              ) : (
                <>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-8">
                      <div className="tableResponsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Product</th>
                              <th
                                style={{ width: "200px", textAlign: "center" }}
                              >
                                Quantity
                              </th>
                              <th
                                style={{ width: "120px", textAlign: "center" }}
                              >
                                Price
                              </th>
                              <th
                                style={{ width: "100px", textAlign: "center" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {cartreduxdata?.map((item, index) => {
                              console.log("Rendering cart item:", item);
                              return (
                                <tr key={index}>
                                  <td>
                                    <strong>{item.name}</strong>
                                    <p>SKU:{item.productid}</p>
                                  </td>
                                  <td>
                                    <div
                                      className="qtyInput"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <i
                                        className="fa-solid fa-minus"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (item.cartquantity > 1) {
                                            handleMinustoCart(item);
                                          }
                                        }}
                                        style={{
                                          cursor:
                                            item.cartquantity <= 1
                                              ? "not-allowed"
                                              : "pointer",
                                          opacity:
                                            item.cartquantity <= 1 ? 0.5 : 1,
                                          fontSize: "16px",
                                          padding: "8px",
                                          color: "#dc3545",
                                        }}
                                      ></i>

                                      <input
                                        type="number"
                                        value={item.cartquantity}
                                        min="1"
                                        max="50"
                                        onChange={(e) =>
                                          handleQuantityChange(
                                            item,
                                            e.target.value
                                          )
                                        }
                                        onClick={(e) => e.stopPropagation()}
                                        onFocus={(e) => {
                                          e.target.select();
                                        }}
                                        onBlur={(e) => {
                                          if (
                                            e.target.value === "" ||
                                            parseInt(e.target.value) < 1
                                          ) {
                                            e.target.value = item.cartquantity;
                                          }
                                        }}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "-" ||
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "+" ||
                                            e.key === "."
                                          ) {
                                            e.preventDefault();
                                          }
                                          if (
                                            e.key === "0" &&
                                            e.target.value === ""
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        style={{
                                          width: "70px",
                                          textAlign: "center",
                                          border: "1px solid #ddd",
                                          borderRadius: "4px",
                                          padding: "8px",
                                          fontSize: "16px",
                                          fontWeight: "bold",
                                        }}
                                      />
                                      <i
                                        className="fa-solid fa-plus"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (item.cartquantity < 50) {
                                            handleAddtoCart(item);
                                          }
                                        }}
                                        style={{
                                          cursor:
                                            item.cartquantity >= 50
                                              ? "not-allowed"
                                              : "pointer",
                                          opacity:
                                            item.cartquantity >= 50 ? 0.5 : 1,
                                          fontSize: "16px",
                                          padding: "8px",
                                          color: "#28a745",
                                        }}
                                      ></i>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                    }}
                                  >
                                    £{parseFloat(item.cartamount).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <i
                                      className="fa-solid fa-trash"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteCartItem(item);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        color: "red",
                                        fontSize: "20px",
                                        transition: "color 0.2s",
                                        padding: "8px",
                                      }}
                                      onMouseEnter={(e) =>
                                        (e.target.style.color = "#a02622")
                                      }
                                      onMouseLeave={(e) =>
                                        (e.target.style.color = "#dc3545")
                                      }
                                      title="Remove from cart"
                                    ></i>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          style={{
                            padding: "20px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <div style={{ fontSize: "16px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <span>Product Total:</span>
                                  <strong>
                                    £{parseFloat(total).toFixed(2)}
                                  </strong>
                                </div>

                                {packtotal > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <span>Additional Packages:</span>
                                    <strong>
                                      £{parseFloat(packtotal).toFixed(2)}
                                    </strong>
                                  </div>
                                )}

                                {personalisedtotal > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <span>Personalised Items:</span>
                                    <strong>
                                      £
                                      {parseFloat(personalisedtotal).toFixed(2)}
                                    </strong>
                                  </div>
                                )}

                                <hr style={{ margin: "15px 0" }} />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "#28a745",
                                  }}
                                >
                                  <span>Grand Total:</span>
                                  <span>
                                    £{parseFloat(grandTotal).toFixed(2)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          align="right"
                          className="d-flex justify-content-between"
                          style={{ marginTop: "20px" }}
                        >
                          {serviceType === 1 ? (
                          <Link to="/">
                            <Button
                              className="btn2"
                              variant="secondary"
                              style={{
                                marginRight: "10px",
                                fontSize: "14px",
                                padding: "14px 17px ",
                              }}
                            >
                              Continue Shopping
                            </Button>
                          </Link>
                          ) : null}

                          {/* ✅ UPDATED: Button with authentication check */}
                          <Button
                            className="btn2"
                            variant="success"
                            style={{ fontSize: "14px", padding: "14px 17px" }}
                            onClick={handleProceedToCheckout}
                          >
                            Proceed to Checkout
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
